export default __webpack_public_path__ + "static/media/chat-app.ee78df69.webp";